import $ from 'jquery';

export const marker = function (type, $el, targetElements, minPos = 0) {
  const markerEl = $($el);
  const HORIZONTAL = 'HORIZONTAL';
  const VERTICAL = 'VERTICAL';
  const HORIZ_Y = 'HORIZ_Y';
  const ANIM_DURATION = 300;

  var offsetType = 'offsetLeft';
  if (type !== 'HORIZONTAL') {
      offsetType = 'offsetTop';
  }

  var minPosition = minPos;
  var lastElementMarked = null;
  var lastPos = null;

  const updateLastElementMarked = (element) => {
    lastElementMarked = element;
  };

  const getLastElementMarked = () => lastElementMarked;

  const translateX = (value, shouldScaleToZero) => {

    let translateStr = shouldScaleToZero ? 
      `translateX(${value}px) scaleX(0)` :
      `translateX(${value}px) scaleX(1)`;
    
    markerEl.css({
      'transform': translateStr,
      '-webkit-transform': translateStr,
      '-moz-transform': translateStr,
      '-ms-transform': translateStr
    });
  };

  const translateY = (value) => {
    let translateStr = `translateY(${value}px)`;

    markerEl.css({
      'transform': translateStr,
      '-webkit-transform': translateStr,
      '-moz-transform': translateStr,
      '-ms-transform': translateStr
    });
  };

  const translate = type === HORIZONTAL ?
      translateX :
      translateY;

  const translateAndHide = (pos) => {
    updateLastElementMarked(null);
    translate(pos, true);
  };

  const translateTo = (element, shouldNotAnimate, pad = 0) => {
    let _element;

    if (element instanceof $) {
      _element = element[0];
    } else {
      _element = element;
    }

    updateLastElementMarked(_element);
    let offsetValue = _element[offsetType];

    if (type === HORIZ_Y) {
        offsetValue = offsetValue + _element.offsetHeight - 4;
    }

    let transitionStr;

    if (shouldNotAnimate) {
      transitionStr = markerEl.css('transition');
      markerEl.css('transition', 'none');
    }

    translate(Math.max(offsetValue, minPosition) + pad);

    if (transitionStr) {
      setTimeout(() => {
        markerEl.css('transition', transitionStr);
      }, 100);
    }
  };


  const onTargetHoverCb = function onTargetHoverCb(e) {
    translateTo(e.currentTarget);
  };

  const setLasPos = (x, y) => {
    lastPos = {x, y};
  };

  const onMouseMove = (e) => {
   setLasPos(e.clientX, e.clientY);
  }

  const unbind = () => {
    $(targetElements).off('mouseover', onTargetHoverCb);
    $container.off('mouseout', onMouseLeaveCb);
  };

  const bind = () => {
    $(targetElements).hover(onTargetHoverCb);
  };

  const changePadTo = (value) => minPosition = value;

  const replayTranslate = (shouldNotAnimate, pad = 0) => {
    if (!lastElementMarked) return;
    translateTo(lastElementMarked, shouldNotAnimate, pad);
  };

  bind();

  return {
    changePadTo,
    replayTranslate,
    translateTo,
    translate,
    translateAndHide,
    updateLastElementMarked
  };
};


// WEBPACK FOOTER //
// ./src/components/header/marker.js